import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from './download-order.svg'


const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "container px-0" }
const _hoisted_4 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_5 = { class: "col-sm-6 col-md-3 mb-1" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative" }
const _hoisted_7 = { class: "col-sm-6 col-md-3 mb-1" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative" }
const _hoisted_9 = { class: "card-title align-items-start flex-column mt-0" }
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Id Transaksi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Pesanan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Pesanan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Pembayaran"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Pesanan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Cek Data"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "badge badge-light-danger badge-text-normal" }
const _hoisted_23 = { class: "badge badge-light-warning badge-text-normal" }
const _hoisted_24 = { class: "badge badge-light-info badge-text-normal" }
const _hoisted_25 = { class: "badge badge-light-primary badge-text-normal" }
const _hoisted_26 = { class: "badge badge-light-success badge-text-normal" }
const _hoisted_27 = { class: "badge badge-light-secondary badge-text-normal" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "row mt-5 mb-5" }
const _hoisted_43 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_44 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_45 = ["label", "value"]
const _hoisted_46 = { class: "p-3" }
const _hoisted_47 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_48 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_card_verification = _resolveComponent("card-verification")!
  const _component_card_update = _resolveComponent("card-update")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.schoolId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.schoolId) = $event)),
                  placeholder: "Pilih Sekolah",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listSchool,
                  searchable: true,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihSekolah($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, [
                  _createVNode(_component_card_verification),
                  _createVNode(_component_card_update)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(item.idTransaction), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.schoolName), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.transactionDate), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.jumlahPesanan), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.paymentStatus), 1),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(item.orderStatus), 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(item.orderStatus), 1),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(item.orderStatus), 1),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(item.orderStatus), 1),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(item.orderStatus), 1),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(item.orderStatus), 1)
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(item.checkData), 1),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "download",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (
                      _ctx.$router.push('/superadmin/data-order/detail/' + item._id)
                    )
                        }, _hoisted_32, 8, _hoisted_30),
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (
                      _ctx.$router.push('/superadmin/data-order/detail/' + item._id)
                    )
                        }, _hoisted_35, 8, _hoisted_33),
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Edit",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (
                      _ctx.$router.push('/superadmin/data-order/edit/' + item._id)
                    )
                        }, _hoisted_38, 8, _hoisted_36)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_39, _hoisted_41))
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_45))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("ul", _hoisted_48, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}